/**
 * log.service.ts
 *
 * Servicio cliente para enviar eventos al logger server-side (Winston).
 * Usa fire-and-forget: nunca bloquea el flujo del usuario si el log falla.
 */

import { connection } from '@/lib/connection';

export interface PaymentErrorPayload {
    message: string;
    gateway?: string | null;
    step?: number | string;
    eventoId?: string;
    funcionId?: string;
    reservaId?: string | null;
    monto?: number;
    status?: number;
    userAgent?: string;
    referrer?: string;
}

/**
 * Loguea un error de pago en el servidor (sin await — fire-and-forget).
 * El servidor enriquece el log con device y origen de tráfico.
 */
export function logPaymentError(payload: PaymentErrorPayload): void {
    const body: PaymentErrorPayload = {
        ...payload,
        userAgent: payload.userAgent ?? (typeof navigator !== 'undefined' ? navigator.userAgent : undefined),
        referrer: payload.referrer ?? (typeof document !== 'undefined' ? document.referrer : undefined),
    };

    // Fire-and-forget: nunca bloquea el flujo del usuario si el log falla
    connection('/api/log/payment-error', 'POST', {}, body)
        .catch(() => { /* silencioso — el log nunca debe interrumpir una compra */ });
}

/**
 * Loguea información general de progreso en el servidor (fire-and-forget).
 */
export function logInfo(payload: any): void {
    const body = {
        ...payload,
        userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : undefined,
    };

    connection('/api/log/info', 'POST', {}, body)
        .catch(() => { /* silencioso */ });
}
